import {connect} from 'react-redux';
import PayBalance from './PayBalance.jsx';
import {
  handlePayBalanceClick,
  handlePurchaseClick
} from './actions';
import {handleWebHooksClick} from 'shared/webHooks/actions';
import {ENVIRONMENT} from 'shared/variables';

const mapStateToProps = state => ({
  balanceDue: state.registration.shared.balanceDue,
  entriesCount: state.registration.shared.entries.length,
  environment: ENVIRONMENT
});

const mapDispatchToProps = dispatch => ({
  onPayBalanceClick: () => dispatch(handlePayBalanceClick()),
  onPurchaseClick: () => dispatch(handlePurchaseClick()),
  onWebHooksClick: (checked) => dispatch(handleWebHooksClick(checked))
});

export default connect(mapStateToProps, mapDispatchToProps)(PayBalance);



// WEBPACK FOOTER //
// ./src/features/registration/manage/PayBalanceContainer.jsx